import { i18n, markdown } from './i18n';

export { i18n, markdown };
